import CollectionTrainingModalComponent from "./CollectionTrainingModalComponent";

export default CollectionTrainingModalComponent;